var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"color":"blue-grey darken-3","size":_vm.getSize}},[(_vm.user.photoUrl)?_c('v-img',{attrs:{"contain":"","src":_vm.extendedPhotoUrl}}):_c('span',{staticClass:"blue-grey--text text--lighten-5 source-initials"},[_vm._v(" "+_vm._s(_vm.getInitials))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }